/**
 * Sprint V19 · Schicht 2 · Stufe 2 (Boardroom-CoS Di 08.09.2026 13:00 Europe/Berlin)
 * ==================================================================================
 * FolgeFrage — Generische Rueckfrage-Komponente Variante Alpha (JSON-generisch).
 *
 * Rendert eine Folge-Frage aus dem Backend (`/api/anliegen/folge-fragen`) wenn
 * der Heuristik-Vorfilter niedrige Confidence liefert. Der User klickt eine
 * Option, deren `fokustyp` als `verdacht_override` an den Anliegen-Generate-Flow
 * durchgereicht wird.
 *
 * Neue Fragen post-launch: Andreas editiert `folge_fragen_v19.json` — kein
 * Code-Deploy noetig.
 */
import React from "react";

const FOKUSTYP_LABEL = {
  hund: "Hund",
  eule: "Eule",
  katze: "Katze",
  biene: "Biene",
};

export default function FolgeFrage({ frage, onSelect }) {
  if (!frage) return null;
  return (
    <div
      data-testid="folge-frage-v19"
      data-frage-id={frage.id}
      className="rounded-md border border-blue-200 dark:border-blue-800/60 bg-blue-50 dark:bg-blue-950/40 p-4"
    >
      <p className="text-xs font-bold uppercase tracking-widest text-blue-700 dark:text-blue-300 mb-2">
        Kurze Rückfrage
      </p>
      <p
        data-testid="folge-frage-text"
        className="text-sm text-slate-800 dark:text-slate-100 leading-relaxed"
      >
        {frage.frage_text}
      </p>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-2">
        {(frage.optionen || []).map((opt, idx) => (
          <button
            key={`${frage.id}-${idx}`}
            type="button"
            data-testid={`folge-frage-option-${opt.fokustyp}`}
            data-fokustyp={opt.fokustyp}
            onClick={() => onSelect && onSelect(opt.fokustyp, opt)}
            className="text-left rounded-md border border-blue-300 dark:border-blue-700 bg-white dark:bg-slate-900 hover:bg-blue-100 dark:hover:bg-slate-800 px-3 py-2 text-sm text-slate-800 dark:text-slate-100 transition-colors"
          >
            {/* Sprint V21 (Boardroom-CoS Mo 07.09.2026-14 Uhr) — Wertfreie
                Rueckfrageoption: KEIN Pfeil-Label mehr, das den Fokustyp
                verraten wuerde. Nur der Verhaltens-Text. */}
            <span className="block font-semibold">{opt.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
